import { createContext, useState, ReactNode } from 'react';

/**
 * Defines the shape of the SidebarContext.
 */
interface SidebarContextType {
  sidebarToggle: boolean;
  toggleSidebar: () => void;
  closeSidebar: () => void;
}

export const SidebarContext = createContext<SidebarContextType | undefined>(
  undefined
);

/**
 * Props for SidebarProvider.
 */
interface SidebarProviderProps {
  children: ReactNode;
}

/**
 * A context provider component that manages the sidebar state.
 */
export const SidebarProvider = ({ children }: SidebarProviderProps) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);

  const toggleSidebar = () => setSidebarToggle((prev) => !prev);
  const closeSidebar = () => setSidebarToggle(false);

  return (
    <SidebarContext.Provider
      value={{ sidebarToggle, toggleSidebar, closeSidebar }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
